// src/services/api/procurement/payables.js
// Endpoints per rettzy-backend/src/modules/procurement/routes/payables.routes.js
import { apiClient } from '../base';

export const getPayablesAgingSummary = async (params = {}) => {
  const response = await apiClient.get('/procurement/payables/summary', { params });
  return response.data;
};

export const getSupplierStatement = async (supplierId, params = {}) => {
  const response = await apiClient.get(`/procurement/payables/suppliers/${supplierId}/statement`, { params });
  return response.data;
};
